
import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './cargoCarrierTypes.actions';
import state from './cargoCarrierTypes.state';
import mutations from './cargoCarrierTypes.mutations';

BaseStore.registerModule(
	'cargoCarrierTypes',
	{
		namespaced: true,
		state,
		actions,
		mutations
	}
);

export default BaseStore;

let { mapState, mapMutations, mapActions } = createNamespacedHelpers('cargoCarrierTypes');

export {
	mapState,
	mapMutations,
	mapActions
};
